<template>
  <div>
    <navigation></navigation>
    <div class="container px-4 mx-auto">
      <h1 class="page-title">
        <span v-if="author">Notebooks by {{ author.name }}</span>
        <span v-else>Author</span>
        <div
          :class="{ 'text-blue': author.favorited.length > 0 }"
          class="text-gray-400 inline-block cursor-pointer relative"
          style="top: 4px;"
          title="Favorite this author"
          v-on:click="author_subscribe(author)"
        >
          <Zondicon class="w-6 h-6 fill-current m-auto" icon="StarFull" />
        </div>
      </h1>

      <div class="notebooks mb-3" v-if="books && books.length > 0">
        <div
          :key="book.id"
          class="notebook flex flex-row bg-white font-bold border border-blue-700 cursor-pointer"
          v-for="book in books"
        >
          <div class="title text-center w-3/4 border border-blue-700">
            <router-link
              :data-cy="`book-link-${book.type}${book.encrypt ? '-enc' : ''}`"
              :to="`/u/${author.username}/${book.slug}`"
              class="text-lg py-4 px-2 block"
            >
              {{ book.name }}
            </router-link>
          </div>
          <div class="link text-center w-1/4 ">
            <!--                  <router-link class="text-lg py-4 px-2 block" :to="{path: 'admin/notes/create', query: { book: book.id }}">Add</router-link>-->
            <div
              :class="{ 'text-blue': book.favorited.length > 0 }"
              class="text-lg py-4 px-2 block text-gray-400"
              title="Favorite this book"
              v-on:click="subscribe(book)"
            >
              <Zondicon class="w-6 h-6 fill-current m-auto" icon="StarFull" />
            </div>
          </div>
        </div>
        <div class="bottom-border border border-blue-700"></div>
      </div>
      <div v-else="!books">No notebooks, yet.</div>

      <!-- <div class="row">
              <div class="col-md-12">
                <div class="book group-links" v-for="book in books" :key="book.id">
                  <router-link :to="'/books/' + author.username + '/' + book.name">{{ book.name }}</router-link>
                </div>
              </div>
            </div> -->
    </div>
  </div>
</template>

<script>
import { API_URL } from "../env.js";
import Navigation from "./Navigation.vue";
import axios from "axios";

export default {
  data() {
    return {};
  },
  created: function() {
    const uri = `${API_URL}/u/${this.$route.params.user}`;
    this.$store.dispatch("BOOKS_USER", uri);
  },
  components: {
    Navigation
  },
  methods: {
    subscribe(book) {
      this.$loading(true);
      let bookCopy = Object.assign({}, book);
      // If the favorited array has something, then it has been favorited
      const favorited = bookCopy.favorited.length > 0;
      if (favorited) {
        bookCopy.favorited = [];
      } else {
        bookCopy.favorited = [{}];
      }
      this.$store.dispatch("aSetBookX", bookCopy);
      let uri = `${API_URL}/books/${book.id}/subscribe`;
      axios
        .post(uri, {}, this.$store.getters.authHeaders)
        .then(res => {})
        .catch(function(error) {
          alert(error);
        })
        .finally(() => {
          this.$loading(false);
        });
    },

    author_subscribe(author) {
      this.$loading(true);
      let authorCopy = Object.assign({}, author);
      // If the favorited array has something, then it has been favorited
      const favorited = authorCopy.favorited.length > 0;
      if (favorited) {
        authorCopy.favorited = [];
      } else {
        authorCopy.favorited = [{}];
      }
      this.$store.dispatch("aSetAuthor", authorCopy);
      let uri = `${API_URL}/users/${author.id}/subscribe`;
      axios
        .post(uri, {}, this.$store.getters.authHeaders)
        .then(res => {})
        .catch(function(error) {
          alert(error);
        })
        .finally(() => {
          this.$loading(false);
        });
    }
  },

  computed: {
    books() {
      return this.$store.state.notes.books;
    },
    author() {
      return this.$store.state.notes.author;
    }
  },
  mounted: function() {
    // tinymce.init({ selector:'#message_content', plugins: 'link, lists' });
  }
};
</script>

<style lang="scss">
// Setting the columns to relative position ruins the editor's stick menu
.col-xl,
.col-xl-auto,
.col-xl-12,
.col-xl-11,
.col-xl-10,
.col-xl-9,
.col-xl-8,
.col-xl-7,
.col-xl-6,
.col-xl-5,
.col-xl-4,
.col-xl-3,
.col-xl-2,
.col-xl-1,
.col-lg,
.col-lg-auto,
.col-lg-12,
.col-lg-11,
.col-lg-10,
.col-lg-9,
.col-lg-8,
.col-lg-7,
.col-lg-6,
.col-lg-5,
.col-lg-4,
.col-lg-3,
.col-lg-2,
.col-lg-1,
.col-md,
.col-md-auto,
.col-md-12,
.col-md-11,
.col-md-10,
.col-md-9,
.col-md-8,
.col-md-7,
.col-md-6,
.col-md-5,
.col-md-4,
.col-md-3,
.col-md-2,
.col-md-1,
.col-sm,
.col-sm-auto,
.col-sm-12,
.col-sm-11,
.col-sm-10,
.col-sm-9,
.col-sm-8,
.col-sm-7,
.col-sm-6,
.col-sm-5,
.col-sm-4,
.col-sm-3,
.col-sm-2,
.col-sm-1,
.col,
.col-auto,
.col-12,
.col-11,
.col-10,
.col-9,
.col-8,
.col-7,
.col-6,
.col-5,
.col-4,
.col-3,
.col-2,
.col-1 {
  position: initial;
}
</style>
